<div class="container-fluid text-center" style="height: 70vh;">
    <img src="../../assets/images/404.svg" style="width: 60%;">
    <div class="home_btn_wrapper">
        <p class="home_btn" [routerLink]="['/home']">Go back to home</p>
    </div>
</div>